import MentoringBagIcon from './MentoringBagIcon.vue';

export default MentoringBagIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/bag/index.ts